module.exports = __webpack_public_path__ + "img/pc-step-3.05b88b6f.jpg";